export default {
    AttachmentModelLifeTimeInfo: {
        datapoint: {
            name: 'AttachmentModelLifeTimeInfo',
            customData: function (info) { return info; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map